import { render } from "./BuyerType.vue?vue&type=template&id=7dfc6489&scoped=true&ts=true&lang=pug"
import script from "./BuyerType.vue?vue&type=script&lang=ts&setup=true"
export * from "./BuyerType.vue?vue&type=script&lang=ts&setup=true"

import "./BuyerType.vue?vue&type=style&index=0&id=7dfc6489&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dfc6489"]])

export default __exports__